import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { HOC } from "../HOC";
export const CheckBoxEx = HOC((props) => {
    const { isError, ...rest } = props;
    return _jsx(React.Fragment, { children: _jsx("input", { type: "checkbox", ...rest }) });
}, "blurOrChange");
